import SearchHeader from '../../Components/Headers/SearchHeader';
import SearchResults from './searchGrid/SearchResults';
import { searchContext } from '../../Context/Context';
import LoadingSpinner from '../../global/Loader/LoaderSpinner';
import { SearchContext } from '../../types';
import { useReducer } from 'react';
import { initialState, searchComponentReducer } from './reducers/searchComponentReducer';

export default function Search() {
  const { view, source, tab, hasValidParams } = searchContext() as unknown as SearchContext;
  const [state, _dispatch] = useReducer(searchComponentReducer, initialState)

  return (
    <>
      <SearchHeader />
      {state.isLoading && <LoadingSpinner />}
      {hasValidParams && view && source && tab ? (
        <div>
          <SearchResults />
        </div>
      ) : (
        <LoadingSpinner />
      )}
    </>
  );
}
